<template>
  <div class="schedule-item-holder" :class="{ 'is-activeName': activeName, 'is-edit': edit, 'is-in-complex': inComplex }">

    <div class="schedule-item" :class="{ 'have-extra-content': checkContent(schedule, ['note', 'EntityExchanges']) }">
      <div v-if="edit" class="schedule-item__left">
        <div class="schedule-item__move" :style="{ visibility: draggable ? 'visible' : 'hidden' }">
          <i class="far fa-arrows-v"></i>
        </div>
      </div>
      <div class="schedule-item__central">
        <div class="schedule-item__central__main">
          <div class="schedule-item__kcal">
            <nuttrema-iconica-kcal
              :text="schedule.Entity.name"
              :image="getImagePath(schedule)"
              :nutrientDefinition="schedule.NutritionInfo">
            </nuttrema-iconica-kcal>
          </div>

          <div class="schedule-item__text">
            <p class="schedule-item--serving-size">
              <span class="serving-size__quantity">
                {{ schedule.quantity_gr | number-format(2) }}g
              </span>
              <span class="serving-size__description">
                - {{ _get(schedule, 'amount', 0) | number-format }}
                {{ _get(schedule, 'EntityServingSize.title', false) || _get(schedule, 'EntityServingSize.description', '') }}
              </span>
            </p>
            <p class="schedule-item---title">
              {{ schedule.title || _get(schedule, 'Entity.name', '') }}
            </p>
            <p class="schedule-item--category" v-if="!_isEmpty(schedule.EntityTypeCategory)">
              {{ _get(schedule, 'EntityTypeCategory.name', '') }}
            </p>
          </div>

          <!-- check permissions for food allergens -->
          <permissions-control-wrapper
             tooltipPlacement="bottom"
             action="permissions.subscribed_plan.food_allergens"
            :clarification="false"
            :permissions="permissions"
            :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.FOOD_ALLERGENS">
            <div slot="allowed" class="schedule-item__allergens">
              <nuttrema-allergens-info :allergens="_get(schedule, 'Allergens')"></nuttrema-allergens-info>
            </div>
          </permissions-control-wrapper>
          <!-- check permissions for food allergens -->

          <div class="schedule-item__nutritions-structure">
            <nuttrema-nutritions-stucture-bars
              :nutritions="schedule.NutritionInfo">
            </nuttrema-nutritions-stucture-bars>
          </div>
        </div>
        <!-- end ~ schedule-item__central__main -->

        <div
           v-if="checkContent(schedule, ['note', 'EntityExchanges'])"
           class="schedule-item__central__content"
          :class="{ 'is-closed': !activeName }">
          <div class="central-content-title">
            <div class="content-title-line"></div>
            <div class="content-title-group">
              <el-button-group>
                <el-button
                   v-if="!_isEmpty(schedule.note)"
                   size="mini"
                   label="note"
                  :type="activeName === 'note' ? 'primary' : ''"
                  @click="changeContent('note')">
                  {{ $t('label.note') }}
                </el-button>
                <el-button
                   v-if="!_isEmpty(schedule.EntityExchanges)"
                   size="mini"
                   label="exchanges"
                  :type="activeName === 'contents' ? 'primary' : ''"
                  @click="changeContent('exchanges')">
                  {{ $t('label.exchanges') }}
                </el-button>
              </el-button-group>
            </div>
            <div class="content-title-line"></div>
          </div>
          <div v-if="activeName" class="central-content-holder">

            <div class="central-content-holder__content">
              <p v-if="activeName === 'note'" class="content--text">{{ schedule.note }}</p>
              <div v-if="activeName === 'exchanges'" class="contents--list">
                <template v-for="exchange in schedule.EntityExchanges">
                  <schedule-type-stuff-to-eat-exchange
                    :Entity="_get(schedule, 'Entity')"
                    :EntityExchange="exchange"
                    :permissions="permissions"
                    :inComplex="true">
                  </schedule-type-stuff-to-eat-exchange>
                </template>
              </div>
            </div>

            <div class="central-content-holder__close">
              <button-resize-toggler
                 class="is-bottom-side"
                :title="$t('label.close')"
                :collapsed="false"
                @click="closeContentHolder">
              </button-resize-toggler>
            </div>
          </div>
        </div>

      </div>
      <!-- end ~ schedule-item__central -->

      <div class="schedule-item__remove" :class="{ 'is-open': showRemove }" @click="toggleShowRemove">
        <popover-question-alert
           buttonTitle="label.remove"
           buttonType="danger"
           popoverWidth="280"
           popoverTitle="label.remove"
           popoverText="label.remove_sure"
           popoverPlacement="top-end"
           buttonSize="small"
          :popoverShouldShow="true"
          @confirmed="handleRemoveScheduleEvent(schedule.id)">
        </popover-question-alert>
      </div>
      <div class="schedule-item__edit">
        <el-button
           type="text"
          @click="handleEditScheduleEvent(schedule.EntityType.code, schedule.entity_id, schedule.id, scheduleType)">
          {{ $t('label.edit') }} <i class="el-icon-arrow-right"></i>
        </el-button>
      </div>
    </div>
    <!-- end ~ schedule-item -->

  </div>
</template>

<script>
import NuttremaAllergensInfo from 'components/ui/allergens/nuttrema-allergens-info';

import ScheduleTypeAbstract from './cmpt-schedule-type-abstract';
import ScheduleTypeStuffToEatExchange from './cmpt-schedule-type-stuff-to-eat-exchange';


export default {
  name: 'cmpt-schedule-type-stuff-to-eat-simple',
  mixins: [ScheduleTypeAbstract],
  components: {
    NuttremaAllergensInfo,
    ScheduleTypeStuffToEatExchange,
  },
  data() {
    return {
      scheduleType: 'simple',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/list/schedule-type/cmpt-schedule-type-stuff-to-eat-simple.vue